export default __webpack_public_path__ + "static/media/20.95227acc.jpg";